import { render, staticRenderFns } from "./ShotValMvpResult.vue?vue&type=template&id=ea380c76&"
import script from "./ShotValMvpResult.vue?vue&type=script&lang=js&"
export * from "./ShotValMvpResult.vue?vue&type=script&lang=js&"
import style0 from "./ShotValMvpResult.vue?vue&type=style&index=0&id=ea380c76&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports